import React, { Fragment, useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { Interweave } from "interweave";
import
{
  BASE_URL,
  GET_CONTENTS_BY_MENU_ID,
  GET_IMAGE_BY_MENU_ID,
  GET_MENU_ITEM_BY_ID,
} from "../../constant/constants";
import Footer from "../../components/footer";
import Scrollbar from "../../components/scrollbar";

function items ( obj )
{
  let content = [];

  // eslint-disable-next-line no-unused-vars
  for ( let key in obj )
  {
    let contentItem = {};
    let objs = obj;

    contentItem[ `${ key }` ] = objs[ key ];
    content.push( contentItem );
  }
  return content;
}

const BlogSinglePage = ( props ) =>
{
  const { id, blogName } = useParams();
  const [ menuContent, setMenuContent ] = useState( {} );
  const [ contents, setContents ] = useState( "" );
  const [ contentsImage, setContentsImage ] = useState( "" );
  const [ blogData, setBlogData ] = useState( {
    content: "",
    image: "",
  } );

  useEffect( () =>
  {
    if ( !blogData?.content )
    {
      fetch( `${ GET_CONTENTS_BY_MENU_ID }/${ id }` )
        .then( ( response ) => response.json() )
        .then( ( data ) =>
        {
          if ( data )
          {
            setContents( data.menu_contents );
            setBlogData( {
              ...blogData,
              content: data?.menu_contents.find( content => content.name === blogName )?.value,
            } );
          }
        } )
        .catch( () => { } );
    }

    // Get Content Image
    if ( !blogData?.image )
    {
      fetch( `${ GET_IMAGE_BY_MENU_ID }/${ id }` )
        .then( ( response ) => response.json() )
        .then( ( data ) =>
        {
          if ( data )
          {
            setContentsImage( data.content_images );
            setBlogData( {
              ...blogData,
              image: data?.content_images[ blogName ],
            } );
          }
        } )
        .catch( () => { } );
    }
  }, [ blogData, blogName, id ] );

  useEffect( () =>
  {
    fetch( `${ GET_MENU_ITEM_BY_ID }/${ id }` )
      .then( ( response ) => response.json() )
      .then( ( data ) =>
      {
        setMenuContent( data );

        console.log( "allmenucontent", data );
      } )
      .catch( () => { } );
  }, [ id ] );

  const newContents = items( contents );
  console.log( "menuContent", blogData );

  return (
    <Fragment>
      {/* <Navbar2 Logo={menuContent?.image} /> */ }
      <section className="wpo-project-single-section section-padding">
        <div className="container">
          <div className="row">
            <div className="col-lg-10 offset-lg-1">
              <div className="wpo-project-single-wrap">
                <div className="wpo-project-single-content">
                  <div className="container-fluid">
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="wpo-project-single-content-img">
                          <img
                            src={ `${ BASE_URL }/media/${ blogData?.image }` }
                            alt=""
                          />

                          <Interweave
                            allowAttributes
                            allowElements
                            disableLineBreaks={ true }
                            content={ blogData?.content }
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />

      <Scrollbar />
    </Fragment>
  );
};
export default BlogSinglePage;
